var map = {
	"./DefiLogo.png": 1493,
	"./FARM.png": 1494,
	"./IDO.png": 1495,
	"./ai.jpg": 1496,
	"./arrow-down-blue.svg": 1497,
	"./arrow-down-grey.svg": 1498,
	"./arrow-right-white.png": 1499,
	"./arrow-right.svg": 1500,
	"./big_unicorn.png": 594,
	"./blast.png": 600,
	"./blue-loader.svg": 599,
	"./circle-grey.svg": 1501,
	"./circle.svg": 1502,
	"./coinbaseWalletIcon.svg": 381,
	"./dropdown-blue.svg": 1503,
	"./dropdown.svg": 1504,
	"./dropup-blue.svg": 1505,
	"./ethereum-logo.png": 318,
	"./fortmaticIcon.png": 382,
	"./headTail/Argentina_Croatia.jpeg": 603,
	"./headTail/Argentina_France.jpeg": 604,
	"./headTail/ArrowLeft.svg": 1506,
	"./headTail/ArrowRight.svg": 1507,
	"./headTail/ChartDown.svg": 1508,
	"./headTail/ChartUp.svg": 1509,
	"./headTail/Croatia_Brazil.jpeg": 605,
	"./headTail/Croatia_Morocco.jpeg": 606,
	"./headTail/England_France.jpeg": 607,
	"./headTail/England_USA.jpeg": 608,
	"./headTail/France_Morocco.jpeg": 609,
	"./headTail/France_Poland.jpeg": 610,
	"./headTail/French_Poland.jpeg": 1510,
	"./headTail/Germany_Japan.jpeg": 611,
	"./headTail/Iran_USA.jpeg": 612,
	"./headTail/Japan_Costa_rica.jpeg": 613,
	"./headTail/Japan_Croatia.jpeg": 614,
	"./headTail/Japan_Spain.jpeg": 615,
	"./headTail/Korea_Brazil.jpeg": 616,
	"./headTail/Korea_Ghana.jpeg": 617,
	"./headTail/Korea_Portugal.jpeg": 618,
	"./headTail/Morocco_Spain.jpeg": 619,
	"./headTail/Moroco_Portugal.jpeg": 620,
	"./headTail/Netherland_Argentina.jpeg": 621,
	"./headTail/Poland_Argentina.jpeg": 622,
	"./headTail/Portugal_Ghana.jpeg": 623,
	"./headTail/Portugal_Uruguay.jpeg": 624,
	"./headTail/Qatar_Ecuador.jpeg": 625,
	"./headTail/USA_Wales.jpeg": 626,
	"./headTail/Uruguay_Korea.jpeg": 627,
	"./headTail/bg1.jpg": 628,
	"./headTail/bg2.png": 629,
	"./headTail/bg3.jpg": 1511,
	"./headTail/bg3.png": 630,
	"./headTail/bronze.svg": 1512,
	"./headTail/event-main.png": 1513,
	"./headTail/event.png": 1514,
	"./headTail/gold.svg": 1515,
	"./headTail/head_tail_text.png": 631,
	"./headTail/homebanner3.jpg": 1516,
	"./headTail/joined.svg": 1517,
	"./headTail/silver.svg": 1518,
	"./headTail/sofi.svg": 1519,
	"./home/card1.png": 1520,
	"./home/card2.png": 1521,
	"./home/card3.png": 1522,
	"./home/cross.svg": 1523,
	"./home/golden.png": 1524,
	"./home/home-zhan.png": 1525,
	"./home/homebanner1.jpg": 1526,
	"./home/homebanner1.png": 1527,
	"./home/new1.jpg": 1528,
	"./home/new2.jpg": 1529,
	"./home/new3.jpg": 1530,
	"./home/new3.png": 1531,
	"./home/new4.jpeg": 1532,
	"./home/new5.png": 1533,
	"./home/part1.png": 1534,
	"./home/part2.png": 1535,
	"./home/part3.png": 1536,
	"./home/step.png": 1537,
	"./ido/CereNetwork_logo_1.png": 1538,
	"./ido/banner-img.png": 1539,
	"./ido/vector.png": 1540,
	"./link.png": 632,
	"./link.svg": 1541,
	"./logo-dark.png": 1542,
	"./logo.png": 593,
	"./logo_purple.png": 1543,
	"./magnifying-glass.svg": 1544,
	"./matic-token-icon.png": 380,
	"./media/github_logo.png": 1545,
	"./media/medium_logo.png": 1546,
	"./media/telegram_logo.png": 1547,
	"./media/twitter_logo.png": 1548,
	"./menu.svg": 1549,
	"./metamask.png": 286,
	"./noise.png": 596,
	"./plus-blue.svg": 1550,
	"./plus-grey.svg": 1551,
	"./portisIcon.png": 383,
	"./predictx/back.svg": 1552,
	"./predictx/bennet.svg": 1553,
	"./predictx/bookmark.svg": 1554,
	"./predictx/calendar.svg": 1555,
	"./predictx/closing.svg": 1556,
	"./predictx/event1.jpg": 1557,
	"./predictx/event2.jpg": 1558,
	"./predictx/leftArrow.svg": 1559,
	"./predictx/like.svg": 1560,
	"./predictx/news1.jpg": 1561,
	"./predictx/news2.jpg": 1562,
	"./predictx/news3.jpg": 1563,
	"./predictx/noBalance.png": 633,
	"./predictx/notifications.svg": 1564,
	"./predictx/paused.svg": 1565,
	"./predictx/popular1.jpg": 1566,
	"./predictx/popular2.jpg": 1567,
	"./predictx/popular3.jpg": 1568,
	"./predictx/popular4.jpg": 1569,
	"./predictx/rightArrow.svg": 1570,
	"./predictx/share.svg": 1571,
	"./predictx/up.svg": 1572,
	"./question-mark.svg": 1573,
	"./question.svg": 1574,
	"./spinner.svg": 1575,
	"./step.png": 1576,
	"./tip.png": 1577,
	"./token-list-logo.png": 1578,
	"./token-list/lists-dark.png": 1579,
	"./token-list/lists-light.png": 1580,
	"./token-logo.png": 598,
	"./tokenlistsgrouped.png": 1581,
	"./top.jpg": 1582,
	"./trustWallet.png": 1583,
	"./vote/Chain.png": 634,
	"./vote/Edit_Portfolio_List.png": 635,
	"./vote/Marketing_Campaign.png": 636,
	"./walletConnectIcon.svg": 384,
	"./x.svg": 1584,
	"./xl_uni.png": 595,
	"./zksync.png": 601
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 366;